import { render, staticRenderFns } from "./Recibos.vue?vue&type=template&id=28bddad4&scoped=true"
import script from "./Recibos.vue?vue&type=script&lang=js"
export * from "./Recibos.vue?vue&type=script&lang=js"
import style0 from "./Recibos.vue?vue&type=style&index=0&id=28bddad4&prod&lang=scss"
import style1 from "./Recibos.vue?vue&type=style&index=1&id=28bddad4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bddad4",
  null
  
)

export default component.exports